<!--
    Component Home
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="content">
		<div class="twoColumnLayout">
			<div class="columnLeft home-collection-container">
				<div
					v-for="(collection, index) in collections"
					class="home-collection link"
					:class="{ 'collection4': index == 3 }"
					:key="collection.getID()"
					@click="$parent.showCard('Collection', [collection.getURLTerm()])"
				>
					<div class="home-collection-image zoomable">
						<img v-if="collection.getImage().isImage()"
							:src="collection.getImage().getImageURL(previewImageQuality)" />
						<div v-else
							v-html="collection.getImage().getMultiMediaHTML(0, 'preview')"></div>	
					</div>
					<div class="home-collection-label">{{ collection.getName() }}</div>
				</div>
			</div>

			<div class="columnCenter">
				<div class="home-exhibition-image zoomable">
					<img
						v-if="exhibition.getImage().isImage()"
						class="link"
						:src="exhibition.getImage().getImageURL('large')"
						@click="$parent.showCard('Exhibition')"
					/>
					<div v-else
						class='link'
						v-html="exhibition.getImage().getMultiMediaHTML(0, 'preview')"
						@click="$parent.showCard('Exhibition')"></div>
				</div>
				<div class="home-exhibition-desc">
					<h2 class="link" @click="$parent.showCard('Exhibition')">{{ exhibition.getName() }}</h2>
					<div v-html="leadTextWithNewLine"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import Vue from "vue";
	import { model } from "./../model/Model.js";

	export default {

		props: ["propFilterTerm"],

		data: function() {
			return {
				collections: model.getCollections().getList().filter(x => { return x.getID() != 0}).slice(0, 4),
				exhibition: model.getExhibitions().getActive(),

				// source of the preview images
				previewImageQuality: 'small',
			};
		},

		computed: {
			// Prepare the Lead Text for display by adding newlines
			leadTextWithNewLine: function() {
				return this.exhibition.getLeadText().replace(/\n/g, "<br>");
			}
		},

		// Initialize the component
		created: function() {
			this.previewImageQuality = Vue.prototype.$previewImageQuality;
		}		

	};
</script>


<style>

@media (min-width: 1000px) {

	div.home-collection {
		width: 18.7rem;
		margin-bottom: 2.2rem;
	}

	div.collection4 {
		display: none;
	}

	div.home-collection-image {
		width: 18.7rem;
		height: 10rem;
		overflow-y: hidden;
	}

	div.home-collection-image img, div.home-collection-image div {
		object-fit: cover;
		object-position: center;
		width: 18.7rem;
		height: 10rem;
	}

	div.home-collection-label {
		font-size: 1rem;
		color: white;
		background-color: #92a8b4;
		padding: 0.3rem 2.4rem 0.3rem 2.4rem;
	}

	div.home-exhibition-image {
		width: 40.4rem;
		height: 23rem;
		overflow-y: hidden;
	}

	div.home-exhibition-image img, div.home-exhibition-image div {
		width: 40.4rem;
	}

	div.home-exhibition-desc {
		margin-top: 2.2rem;
	}

	div.home-exhibition-desc h2 {
		margin-bottom: 1rem;
	}
}

@media (max-width: 1000px) {

	div.home-collection-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-right: -2rem;
	}

	div.home-collection {
		position: relative;
		flex-basis: calc(50% - 2rem);
		height: same-as-width;
		margin-bottom: 2rem;
		margin-right: 2rem;
	}

	div.home-collection-image {
		max-height: 14rem;
	}

	div.home-collection-image img, div.home-collection-image div {
		width: 100%;
		object-fit: cover;
		object-position: center;
	}

	div.home-collection-label {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;

		font-size: 1.2rem;
		color: white;
		background-color: #92a8b4;
		padding: 0.5rem 2.4rem 0.5rem 2.4rem;
	}

	div.home-exhibition-image img, div.home-exhibition-image div {
		width: 100%;
		max-width: 100%;
		max-height: 25rem;
		object-fit: cover;
		object-position: center;
	}

	div.home-exhibition-desc {
		margin-top: 2rem;
	}

	div.home-exhibition-desc h2 {
		margin-bottom: 1rem;
	}
}

</style>